import { defineMessages } from 'react-intl';

export const i18n = defineMessages({
  haveAnAccount: {
    id: 'contactInformation.haveAnAccount',
    defaultMessage: 'Have a Key Travel account?'
  },
  signIn: {
    id: 'contactInformation.signIn',
    defaultMessage: 'Sign In',
  },
  logout: {
    id: 'contactInformation.logout',
    defaultMessage: 'Log out',
  },
  nevemind: {
    id: 'contactInformation.nevemind',
    defaultMessage: 'Nevermind',
  },
  iDontHaveAnAccount: {
    id: 'contactInformation.iDontHaveAnAccount',
    defaultMessage: "I don't have an account",
  },
});



// WEBPACK FOOTER //
// ./src/desktop/pages/single-payer-payment/contact-information.i18n.js